module.exports = __webpack_public_path__ + "img/113022.5f0a81c7.png";